import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StandardOverview.module.css';

const OverviewHeader = ({ model }) => {
    const navigate = useNavigate();
    const [logoFailed, setLogoFailed] = useState(false);

    useEffect(() => {
        setLogoFailed(false);
    }, [model.logo]);

    const showLogo = Boolean(model.logo) && !logoFailed;

    return (
        <header className={styles.pageHeader}>
            <div className={showLogo ? `${styles.pageHeaderLead} ${styles.pageHeaderLeadWithLogo}` : styles.pageHeaderLead}>
                {showLogo ? (
                    <div className={styles.projectLogo}>
                        <img src={model.logo} alt="" onError={() => setLogoFailed(true)} />
                    </div>
                ) : null}
                <div className={styles.pageHeaderMain}>
                    <p className={styles.pageEyebrow}>Project Overview</p>
                    <h1 className={styles.pageTitle}>{model.projectName}</h1>
                    <p className={styles.pageSubtitle}>{model.subtitle}</p>
                    <ul className={styles.metaRow}>
                        {model.metaItems.map(item => (
                            <li key={item}>{item}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className={styles.pageHeaderActions}>
                <button type="button" className={styles.textAction} onClick={() => navigate('/project-information')}>
                    View project information →
                </button>
                <button type="button" className={styles.textAction} onClick={() => navigate('/team/vdr')}>
                    Manage team &amp; access →
                </button>
            </div>
        </header>
    );
};

export default OverviewHeader;
